export default (allProjectOwners, contactList) =>
	allProjectOwners.filter((projectOwner) => contactList.some(({userId}) => userId === projectOwner.userId));
